import { useObservable } from '@hooks/useObservable';

import { contractStore } from '../contractStore';

/** Utility hook for obtaining the currently selected contract id. */
export const useContractId = () =>
  useObservable(() => contractStore.selectedContractId);
